module.exports = __webpack_public_path__ + "static/media/ipad-8.3f463966.jpg";